import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import WithRouter from '../Extensions/WithRouter';
//import Loader from '../Loader/Loader';
//import api from '../../api';

class FilterFormWithSaveModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterName: '',
      filterNameError: '',
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getByteLength = this.getByteLength.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMFF } = this.props;

    if (prevProps.isOpenMFF !== isOpenMFF) {
      this.setState({
        filterName: '',
        filterNameError: '',
      });
    }
  }

  handleNameChange(e) {
    this.setState({
      filterName: e.target.value,
      filterNameError: '',
    });
  }

  onSubmit() {
    const { rowData, onSubmit } = this.props;
    const { filterName } = this.state;
    if (!this.validateFields()) {
      return null;
    }

    const projects = [];
    const project_versions = [];

    rowData.map((item) => {
      projects.push(item.data.id);
      if (item.children.length !== 0) {
        item.children.map((x) => {
          project_versions.push(x.data.id);
          return project_versions;
        });
        return item.children;
      }
      return item;
    });

    const obj = {
      name: filterName,
      projects,
      project_versions,
    };

    onSubmit(obj);
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += text.charCodeAt(i) > 128 ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  validateFields() {
    const { translate } = this.props;
    const { filterName } = this.state;

    const validation = {
      filterName: true,
    };

    if (filterName.trim().length === 0) {
      this.setState({
        filterNameError: translate('navibar.filter_name_required'),
      });
      validation.filterName = false;
      return false;
    }
    return validation.filterName;
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  render() {
    const {
      translate,
      isOpenMFF,
      rowData
    } = this.props;
    const { filterName, filterNameError } = this.state;

    const filterNameErrorClass = filterNameError !== '' ? 'show' : '';

    // eslint-disable-next-line react/no-unstable-nested-components
    function TreeView({ treeData = [] }) {
      /*
      const toggleBranch = (e) => {
        console.log(e);
      };
      */

      return (
        <ul>
          {treeData.map((item) => {
            return (item.data.name
              ? (
                <li key={item.data.id}>
                  <span
                    data-id={item.data.id}
                    //onClick={toggleBranch}
                    //onKeyUp={toggleBranch}
                  >
                    {item.data.name}
                  </span>
                  {item.children && <TreeView key={item.data.id} treeData={item.children} />}
                </li>
              )
              : null);
          })}
        </ul>
      );
    }

    return (
      <Modal open={isOpenMFF} onClose={this.closeModal}>
        <form className="frmAddVersion filter">
          <div className="add_popup">
            <div className="add_popup_item">
              <h2 className="title">{translate('navibar.save_filter')}</h2>
              <div className="add_popup_item_content">
                <div className="label">
                  {translate('navibar.filter_name')}
                  <em style={{ marginLeft: '0' }} className="asterisk" />
                </div>
                <div className={`value ${filterNameErrorClass}`}>
                  <input
                    type="text"
                    value={filterName}
                    onChange={this.handleNameChange}
                    placeholder={translate('navibar.saved_filter_name')}
                  />
                  <div className={`error ${filterNameErrorClass}`}>{filterNameError}</div>
                </div>
              </div>
              <Scrollbars
                style={{
                  height: '300px',
                  overflow: 'hidden',
                  position: 'relative',
                }}
                renderTrackHorizontal={() => {
                  return <div />;
                }}
                renderThumbHorizontal={() => {
                  return <div />;
                }}
              >
                <div className="tree_container">
                  <TreeView treeData={rowData} />
                </div>
              </Scrollbars>
              <div className="add_popup_bottom">
                <a className="cancel" onClick={this.closeModal} onKeyUp={this.closeModal}>
                  {translate('modal.button.cancel')}
                </a>
                <a className="save" onClick={this.onSubmit} onKeyUp={this.onSubmit}>
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(FilterFormWithSaveModal)));
